import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SavePinCommandClass;
function SavePinCommand() {
  if (SavePinCommandClass === VOID) {
    class $ {
      constructor(id, pin) {
        this.n2n_1 = id;
        this.o2n_1 = pin;
      }
      df() {
        return this.n2n_1;
      }
      ef() {
        return this.o2n_1;
      }
      toString() {
        return 'SavePinCommand(id=' + this.n2n_1.toString() + ', pin=' + this.o2n_1.toString() + ')';
      }
      hashCode() {
        var result = this.n2n_1.hashCode();
        result = imul(result, 31) + this.o2n_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinCommand()))
          return false;
        if (!this.n2n_1.equals(other.n2n_1))
          return false;
        if (!this.o2n_1.equals(other.o2n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinCommand');
    SavePinCommandClass = $;
  }
  return SavePinCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcherb76d0p5pxiow,
  SavePinCommand as SavePinCommand2khg9326u1dzu,
};
//endregion

//# sourceMappingURL=SavePinCommand.mjs.map
